/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Claims_CollectInputs */

const en_claims_collect = /** @type {(inputs: Claims_CollectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collect`)
};

const fr_claims_collect = /** @type {(inputs: Claims_CollectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frais virés`)
};

/**
* | output |
* | --- |
* | "Collect" |
*
* @param {Claims_CollectInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const claims_collect = /** @type {((inputs?: Claims_CollectInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Claims_CollectInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_claims_collect(inputs)
	return fr_claims_collect(inputs)
});